module.exports = "../images/fishing-on-lake-home@2x.jpg?v=e78d6d9";